import { useState } from "react";
import "./Arti.scss";
import { aratiData } from "./Arti";


const LANGUAGE_LABELS = {
  hi: "हिन्दी",
  en: "ENGLISH",
  bn: "বাংলা",
};

const Arti = () => {
  const godKeys = Object.keys(aratiData);

  const [activeGod, setActiveGod] = useState(godKeys[0]);
  const [activeAarti, setActiveAarti] = useState(null);
  const [language, setLanguage] = useState("hi");

  const god = aratiData[activeGod];

  return (
    <div className="arati-container">

      <div className="arati-card">

        {/* GOD SELECTOR (TOP) */}
        <div className="god-selector">
          {godKeys.map((key) => (
            <button
              key={key}
              className={key === activeGod ? "active" : ""}
              onClick={() => {
                setActiveGod(key);
                setActiveAarti(null);
              }}
            >
              {aratiData[key].name}
            </button>
          ))}
        </div>

        {/* IMAGE + AARTI TILES */}
        <div className="hero-section">

          {/* IMAGE */}
          <div className="god-section">
            <img
  src={god.image}
  alt={god.name}
  
/>
            <h1>{god.name}</h1>
            <span className="subtitle">Aarti & Mantra</span>
          </div>

          {/* TILES */}
          <div className="arati-tiles">
            {god.aratis.map((aarti) => (
              <div
                key={aarti.id}
                className={`arati-tile ${activeAarti?.id === aarti.id ? "active" : ""}`}
                onClick={() => setActiveAarti(aarti)}
              >
                {aarti.title}
              </div>
            ))}
          </div>

        </div>

        {/* LANGUAGE + LYRICS */}
        {activeAarti && (
          <>
<div className="language-toggle">
  {Object.keys(activeAarti.lyrics).map((lang) => (
    <button
      key={lang}
      className={language === lang ? "active" : ""}
      onClick={() => setLanguage(lang)}
    >
      {LANGUAGE_LABELS[lang] || lang.toUpperCase()}
    </button>
  ))}
</div>


            <div className="arati-lyrics">
              {activeAarti.lyrics[language].map((line, i) => (
                <p
                  key={i}
                  className={
                    line.startsWith("॥")
                      ? "arati-title"
                      : line.startsWith("(")
                      ? "arati-optional"
                      : ""
                  }
                >
                  {line}
                </p>
              ))}
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default Arti;
